const mutations = {
	// Name of the destructured object is payload
	openDropdown: function(state, { status, id }) {
		state.openDropdown.status = status,
		state.openDropdown.id = id
	},
	initDrawer: function(state, drawer) {
		state.globals.drawer = drawer;
	},
	SET_DRAWER: function(state, payload) {
    state.globals.drawer = payload !== undefined ? payload : !state.globals.drawer;
	},
  SET_PRODUCT: function(state, payload) {
    try {
      state.pages.product.properties = payload;
    } catch(err) {
      state.pages.product.properties = undefined;
    }
    state.pages.product.loading = false;
  },
  SET_PRODUCT_LOADING: function (state, payload) {
    state.pages.product.loading = payload;
  },
  SET_VARIANT: function(state, payload) {
    state.pages.product.active.colour = payload.colourCode;
    state.pages.product.active.url = `${payload.url}/${payload.colourCode}`;
  },
  SET_BRANDS: function(state, payload) {
    // let obj = {};

    // for (let i=0; i < payload.length; i++) {
    //   if (state.pages.home.brands[i] !== undefined) {
    //     state.pages.home.brands[i].id = payload[i].data.id
    //     state.pages.home.brands[i].title = payload[i].data.alt_text;
    //     state.pages.home.brands[i].img = payload[i].data.source_url;
    //   } else {
    //     obj = {
    //       id: payload[i].data.id,
    //       title: payload[i].data.alt_text,
    //       img: payload[i].data.source_url,
    //     };
    //     state.pages.home.brands.push(obj);
    //   }
    // }
    for (let i = 0; i < payload.length; i++) {
      state.pages.home.brands.push(payload[i]);
    }
  },
  SET_CATALOGUE: function(state, payload) {
    let obj = {};
    state.pages.home.plainImg = [];
    for (let i=0; i < payload.length; i++) {
      obj = {
        id: payload[i].data.id,
        title: payload[i].data.alt_text,
        img: payload[i].data.source_url,
      };
      state.pages.home.plainImg.push(obj);
    }
  },

  SET_VARIETY_TAB: function (state, payload) {
    state.pages[payload.page].varietyTabs = payload.data;
  },

  SET_CURRENT_TAB: function (state, payload) {
    // If the payload is null, set the tabs as false to trigger loading
    if(!payload) {
      state.pages.brand.tabs = false;
      return;
    }

    state.pages.brand.tabs = state.pages[payload].varietyTabs;
  },
  
  SET_VARIETY_PRODUCTS: function (state, payload) {
    state.pages.brand.tabContent = payload;
  },
  
  SET_CURRENT_TAB_PRODUCTS: function (state, payload) {
    if(!payload) {
      state.pages.brand.tabContent = false;
      return;
    }
    state.pages.brand.tabContent = payload;
  },
};

export default mutations;
